"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
 * Memoized hook to extract necessary Launch-Darkly configuration for the LDProvider
 */
var react_1 = require("react");
var getOr_1 = (0, tslib_1.__importDefault)(require("lodash/fp/getOr"));
var config_1 = require("../config");
var useAuth_1 = require("../auth/useAuth");
var LAUNCH_DARKLY_CLIENT_KEY = 'LaunchDarkly.clientKey';
var useLDConfig = function () {
    var ntConfig = (0, config_1.useNTConfig)();
    var cognitoUUID = (0, useAuth_1.useAuth)().cognitoUUID;
    var memoizedLDConfig = (0, react_1.useMemo)(function () { return ({
        clientSideID: (0, getOr_1.default)('', LAUNCH_DARKLY_CLIENT_KEY, ntConfig),
        context: {
            key: cognitoUUID,
        },
        options: {
            bootstrap: 'localStorage',
            streaming: false,
        },
    }); }, [cognitoUUID, ntConfig]);
    return memoizedLDConfig;
};
exports.default = useLDConfig;
